import { useGetClientAdminUser } from '~/hooks';
import { EditClientAdminUserFormPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof EditClientAdminUserFormPresentation>;

type Args = {
  data: ReturnType<typeof useGetClientAdminUser>['data'];
};

type IConvertToPresentationProps = (args: Args) => Pick<PresentationProps, 'title'>;

/**
 * API レスポンスの企業管理者データを Presentation Props に変換する
 */
export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  const { client_admin_user } = data;
  return {
    title: `${client_admin_user.full_name}の編集`,
  };
};
